var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScrollupSection'),_c('div',{staticClass:"main"},[_c('HeaderSection'),_c('InnerBreadcrumb'),_c('ReviewSection'),_c('FaqSection'),_c('FooterSection')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }